module.exports = __webpack_public_path__ + "static/media/navika.8d13e0bc.jpg";